export class Messages {
    public static onValidated = "on-validated";
    public static documentClick = "document-click";
    public static updateUser = "update-user";
    public static changeEntityItemStep = "change-entity-item-step";
    public static refreshChangeLog = "refresh-changelog";
    public static refreshAttachments = "refresh-attachments";
    public static attachmentsModified = "attachments-modified";
    public static attachmentsLoaded = "attachments-loaded";
    public static workflowCompleted = "workflow-completed";
    public static showDatePicker = "show-date-picker";
    public static hideDatePicker = "hide-date-picker";
    public static comboSelected = "combo-selected"
    public static multiComboSelected = "multi-combo-selected"
    public static buttonClick = "button-click";
    public static cardClick = "card-click";
    public static unlockFeature = "unlock-feature";
    public static requestNowVHCBadgeClick = "request-now-vhc-badge-click";
    public static InspectedVesselChanged = "inspected-vessel-changed";
    public static hasOriginalSpeedPowerCurveUpdatedChanged = "has-original-speed-power-curve-updated-changed";
    public static validCloseOut = "valid-close-out";
    public static navigateVesselSsTabs = "navigate-vessel-ss-tabs";
    public static changePscDeficiency = "change-psc-deficiency";
}
